import { render, staticRenderFns } from "./client-wigs-list.vue?vue&type=template&id=10ace3d0&scoped=true"
import script from "./client-wigs-list.vue?vue&type=script&lang=js"
export * from "./client-wigs-list.vue?vue&type=script&lang=js"
import style0 from "./client-wigs-list.vue?vue&type=style&index=0&id=10ace3d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ace3d0",
  null
  
)

export default component.exports